import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getProductById } from '../../../../api/product/queries/getProductById';
import { IProduct } from '../../../../interfaces/Product.interfaces';

interface IUseGetProductByIdQueryParams {
  productId: string;
  searchParam?: {
    fields?: string;
  };
}

export const useGetProductByIdQuery = ({ searchParam, productId }: IUseGetProductByIdQueryParams) => {
  return useQuery<IProduct, AxiosError>(
    ['product_by_id', productId, `fields=${searchParam?.fields}`],
    () => getProductById({ productId, searchParam }),
    {
      enabled: Boolean(productId),
    },
  );
};
